import React from 'react';
import { Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

import { BasicCodeCombo } from '../core/BasicCodeCombo';
import { BasicIdCombo } from '../core/BasicIdCombo';

type Props = {
  scenarioCode: string;
  sessionId: number | '';
  sessionName: string;
  pressureId: number | '';
  sourceCode: string;
  decisionCode: string;
  scenarios: any[];
  sessions: any[];
  sources: any[];
  decisions: any[];
  loading?: boolean;
  onScenarioChange: (code: string) => void;
  onSessionChange: (rid: number | '') => void;
  onSessionNameChange: (name: string) => void;
  onPressureIdChange: (rid: number | '') => void;
  onSourceChange: (code: string) => void;
  onDecisionChange: (code: string) => void;
  onGenerate: () => void;
  onRecommend: () => void;
  onRefresh: () => void;
};

class BudgetValidationFilterBar extends React.Component<Props> {
  upper = (fn: (value: string) => void) => (value: string) =>
    fn(String(value || '').toUpperCase());

  render() {
    const p = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'center' }} spacing={2} sx={{ mb: 2 }}>
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Budget Validation Filters</Typography>
            <Typography variant="caption" color="text.secondary">
              Select a scenario/session, then filter queue items by source and decision status.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={p.onRefresh} disabled={p.loading}>Refresh</Button>
            <Button variant="outlined" startIcon={<AutoFixHighIcon />} onClick={p.onRecommend} disabled={p.loading || !p.sessionId}>Recommend</Button>
            <Button variant="contained" startIcon={<PlayArrowIcon />} onClick={p.onGenerate} disabled={p.loading || !p.scenarioCode}>Generate Session</Button>
          </Stack>
        </Stack>

        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 2 }}>
            <BasicCodeCombo label="Scenario" items={p.scenarios || []} value={p.scenarioCode || ''} onChange={this.upper(p.onScenarioChange)} disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <BasicIdCombo label="Session" items={p.sessions || []} value={p.sessionId} onChange={p.onSessionChange} disabled={p.loading} helperText="Validation session recid" />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField size="small" type="number" label="Pressure ID" value={p.pressureId} onChange={(e) => p.onPressureIdChange(e.target.value === '' ? '' : Number(e.target.value))} disabled={p.loading} fullWidth helperText="Optional" />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <TextField size="small" label="Session Name" value={p.sessionName || ''} onChange={(e) => p.onSessionNameChange(e.target.value)} disabled={p.loading} fullWidth />
          </Grid>
          <Grid size={{ xs: 12, md: 1.5 }}>
            <BasicCodeCombo label="Source" items={p.sources || []} value={p.sourceCode || ''} onChange={this.upper(p.onSourceChange)} disabled={p.loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 1.5 }}>
            <BasicCodeCombo label="Decision" items={p.decisions || []} value={p.decisionCode || ''} onChange={this.upper(p.onDecisionChange)} disabled={p.loading} />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default BudgetValidationFilterBar;
